import { Fragment, useState } from "react";
import styled from "styled-components/macro";
import { CircularProgress, Grid, Typography } from "@mui/material";

import { Paper } from "../../../components";
import { toInternationalFormat } from "../../../utils";
import { HeadingEighteen, colors } from "../../css components/Style";
import { brandDetailsObject } from "../../brand components/brand details components/brandDetailObject";
import BrandDetailsDialog from "../brand details components/BrandDetailsDialog";

let siteColors = JSON.parse(sessionStorage.getItem("siteColors"));

const Subtitle = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  mix-blend-mode: normal;
  opacity: 0.4;
`;

const Link = styled(Typography)`
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  color: ${siteColors?.primary};
  cursor: pointer;
`;

const ActiveHeading = styled(Typography)`
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function Connections({ setRetry, connections, formikProps }) {
  const [brandDetails, setBrandDetails] = useState({
    data: brandDetailsObject,
    state: false,
  });

  if (!connections) {
    return (
      <Wrapper
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px 0",
        }}
      >
        <CircularProgress sx={{ color: "#02A0FC" }} />
      </Wrapper>
    );
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        {connections?.map((connection, index) => (
          <Grid item xs={12} key={connection?.brand_id}>
            <Paper>
              <Grid item xs={6}>
                <Link>Connection</Link>
              </Grid>

              <Grid
                item
                xs={6}
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
                gap={3}
              >
                {/* Request Status */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    style={{ marginRight: 8 }}
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="5"
                      cy="5"
                      r="5"
                      fill={
                        connection.requestStatus !== "REQUESTED"
                          ? connection.requestStatus === "ACCEPTED"
                            ? colors.green
                            : colors.error
                          : colors.warning
                      }
                    />
                  </svg>

                  <div>
                    <Subtitle>Request Status</Subtitle>
                    <ActiveHeading
                      color={
                        connection.requestStatus !== "REQUESTED"
                          ? connection.requestStatus === "ACCEPTED"
                            ? colors.green
                            : colors.error
                          : colors.warning
                      }
                    >
                      {connection.requestStatus?.replace(/_/g, " ") || "N.A"}
                    </ActiveHeading>
                  </div>
                </div>

                {/* Connection Status */}
                <div>
                  <Subtitle>Fetch Status</Subtitle>
                  <ActiveHeading sx={{ color: colors.primary }}>
                    {connection.status?.replace(/_/g, " ") || "N.A"}
                  </ActiveHeading>
                </div>
              </Grid>

              <Grid item xs={2}>
                <div style={{ display: "flex" }}>
                  <Subtitle>Partner</Subtitle>
                </div>
                <HeadingEighteen>
                  {`Partner ${index + 1}` || "N.A"}
                </HeadingEighteen>
              </Grid>

              <Grid item xs={2} style={{ paddingLeft: "0px" }}>
                <Subtitle> Location</Subtitle>
                <HeadingEighteen sx={{ textTransform: "uppercase" }}>
                  {connection?.locations?.length > 1
                    ? connection?.locations
                        .map((loc) => loc?.substr(0, 2))
                        .join(", ")
                    : connection?.locations[0]?.substr(0, 2)}
                </HeadingEighteen>
              </Grid>

              <Grid item xs={2} style={{ paddingLeft: "0px" }}>
                <Subtitle> Languages</Subtitle>
                <HeadingEighteen sx={{ textTransform: "uppercase" }}>
                  {connection.languages?.length > 1
                    ? connection?.languages
                        ?.map((lan) => lan?.substr(0, 2))
                        .join(", ")
                    : connection?.languages[0]?.substr(0, 2)}
                </HeadingEighteen>
              </Grid>

              <Grid item xs={2} style={{ paddingLeft: "0px" }}>
                <Subtitle> Category</Subtitle>
                <HeadingEighteen sx={{ textTransform: "uppercase" }}>
                  {connection?.category?.length > 1
                    ? connection?.category?.map((lan) => lan).join(", ")
                    : connection?.category[0]}
                </HeadingEighteen>
              </Grid>

              <Grid item xs={2} style={{ paddingLeft: "0px" }}>
                <Subtitle>Total User Count</Subtitle>
                <HeadingEighteen
                  sx={{ textTransform: "uppercase" }}
                  style={{ color: "#4339F2" }}
                >
                  {toInternationalFormat(connection?.totalUsersCount) || "N.A"}
                </HeadingEighteen>
              </Grid>

              <Grid item xs={2} style={{ paddingLeft: "0px" }}>
                <Subtitle>Current User Count</Subtitle>
                <HeadingEighteen
                  sx={{ textTransform: "uppercase" }}
                  style={{ color: "#4339F2" }}
                >
                  {toInternationalFormat(connection?.usersCount) || "N.A"}
                </HeadingEighteen>
              </Grid>
              <Grid item xs={1} />
            </Paper>
          </Grid>
        ))}
      </Grid>
      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />
    </Fragment>
  );
}
